import ReactApexChart from 'react-apexcharts';

const Bar = ({ categories, series, height = 350 , isStacked = false , isHorizontal = false }) => {
  var themeFont = getComputedStyle(document.body).getPropertyValue('--bs-body-font-family').trim();
  var inverse = getComputedStyle(document.body).getPropertyValue('--bs-inverse').trim();
  var inverseRgb = getComputedStyle(document.body).getPropertyValue('--bs-inverse-rgb').trim();
  var themeFontWeight = getComputedStyle(document.body)
    .getPropertyValue('--bs-body-font-weight')
    .trim();
  var gray500 = getComputedStyle(document.body).getPropertyValue('--bs-gray-500').trim();
  // var orange = getComputedStyle(document.body).getPropertyValue('--bs-warning').trim();
  var borderColor = getComputedStyle(document.body).getPropertyValue('--bs-border-color').trim();
  // var themeColorRgb = getComputedStyle(document.body).getPropertyValue('--bs-theme-rgb').trim();

  const themeColor = (getComputedStyle(document.body).getPropertyValue('--bs-theme')).trim();

  const barOptions = {
    
       chart: {
        type: 'bar',
        stacked: isStacked,
      },
    plotOptions: { bar: { horizontal: isHorizontal, dataLabels: { position: 'top' } } },
    // plotOptions: { bar: { horizontal: false, dataLabels: { position: 'top' } } },
    dataLabels: { enabled: true, offsetX: -6, style: { fontSize: '12px', colors: ['#ffffff'] } },
    colors: [themeColor, gray500],
    stroke: { show: false },
    grid: { borderColor: borderColor },
    xaxis: {
      // categories: [2018, 2019, 2020, 2021, 2022, 2023, 2024],
      categories,
      axisBorder: {
        show: true,
        color: 'rgba(' + inverseRgb + ', .25)',
        height: 1,
        width: '100%',
        offsetX: 0,
        offsetY: -1,
      },
      axisTicks: {
        show: true,
        borderType: 'solid',
        color: 'rgba(' + inverseRgb + ', .25)',
        height: 6,
        offsetX: 0,
        offsetY: 0,
      },
      labels: {
        style: {
          colors: inverse,
          fontSize: '12px',
          fontFamily: themeFont,
          fontWeight: themeFontWeight,
          cssClass: 'apexcharts-xaxis-label',
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: inverse,
          fontSize: '12px',
          fontFamily: themeFont,
          fontWeight: themeFontWeight,
          cssClass: 'apexcharts-xaxis-label',
        },
      },
    },
    legend: { fontFamily: themeFont, labels: { colors: inverse } },
  };

  return <ReactApexChart options={barOptions} series={series} type="bar"  height={height} />;
};

export default Bar;
